

// Function to create columns with click handler
import React, { useState } from "react";
import { Button, message, Input } from "antd"
import { SearchOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import { UsimInventoryItem } from "../../../../api/usim/inventory/inventoryItem";
import { formatDateISO, formatDateTimeISO } from "../../../../utils/date";

type SearchProps = {
  iccidSearch: string;
  setIccidSearch: (v: string) => void;
  handleIccidSearch: () => void;
  mobileSearch: string;
  setMobileSearch: (v: string) => void;
  handleMobileSearch: () => void;
  productTypeSearch: string;
  setProductTypeSearch: (v: string) => void;
  handleProductTypeSearch: () => void;
};

export const createInventoryTableColumns = (
  onDetailsClick: (item: any) => void,
  {
    iccidSearch, setIccidSearch, handleIccidSearch,
    mobileSearch, setMobileSearch, handleMobileSearch,
    productTypeSearch, setProductTypeSearch, handleProductTypeSearch
  }: SearchProps
) => {

  return [
  {
    title: "Order Number",
    dataIndex: "ordernumber",
    key: "ordernumber",
    render: (value: string | string[]) => {
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      return value;
    },
  },

  {
    title: (
      <div>
        <div>ICCID/SN</div>
        <Input
          placeholder="Search ICCID/SN"
          value={iccidSearch}
          onChange={e => setIccidSearch(e.target.value)}
          suffix={
            <SearchOutlined
              onClick={() =>handleIccidSearch()}
              style={{ cursor: 'pointer' }}
            />
          }
        />
      </div>
    ),
    dataIndex: "ICCID",
    key: "ICCID",
    render: (value: string) => {
      const text = isNaN(Number(value)) ? "" : value;
      if (!text) return "";
      return (
        <span
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            navigator.clipboard.writeText(text)
              .then(() => message.success("Copied"))
              .catch(() => message.error("Copy failed"));
          }}
        >
          {text}
        </span>
      );
    },
  },

  {
    title: (
      <div>
        <div>Mobile Number</div>
        <Input
          placeholder="Search Mobile Number"
          value={mobileSearch}
          onChange={e => setMobileSearch(e.target.value)}
          suffix={
            <SearchOutlined
              onClick={() => handleMobileSearch()}
              style={{ cursor: 'pointer' }}
            />
          }
        />
      </div>
    ),
    dataIndex: "mobileNumber",
    key: "mobileNumber",
  },
  {
    title: (
      <div>
        <div>Product Type</div>
        <Input
          placeholder="Search Product Type"
          value={productTypeSearch}
          onChange={e => setProductTypeSearch(e.target.value)}
          suffix={
            <SearchOutlined
              onClick={() => handleProductTypeSearch()}
              style={{ cursor: 'pointer' }}
            />
          }
        />
      </div>
    ),
    dataIndex: "productType",
    key: "productType",
  },
  {
    title: "Product SKU",
    dataIndex: "planName",
    key: "planName",
  },
  {
    title: "Expiry Date",
    dataIndex: "expiryDate",
    key: "expiryDate",

    render: (value: string) => value ? formatDateISO(value) : "-",
  },
  {
    title: "Arrival Date",
    dataIndex: "activationDate",
    key: "activationDate",
    render: (value: string) => value ? formatDateISO(value) : "-",
  },
  {
    title: "Activation Submission Date",
    dataIndex: "activatedDate",
    key: "activatedDate",
    render: (value: string) => value ? formatDateTimeISO(value) : "-",
  },

  {
    title: "Inward Time",
    dataIndex: "inwardTime",
    key: "inwardTime",
    render: (value: string, record: UsimInventoryItem) => value ? value : formatDateTimeISO(record?.CreatedAt),
  },

  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Details",
    key: "Details",
    render: (_: any, record: UsimInventoryItem) => {
      return (
        <Button
          type="dashed"
          onClick={() => onDetailsClick(record)}
        >
          Details
        </Button>
      )
    }
  },
];
}
